import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  fetchClientReminder,
  postClientClientReminder,
} from "../../api/clientReminderApi";
import * as Endpoints from "../../entities/Endpoints";

export const fetchClientReminderThunk = createAsyncThunk(
  Endpoints.GET_CLIENT_REMINDER,
  async ({ clientId }, { rejectWithValue }) => {
    try {
      const data = fetchClientReminder({ clientId });
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const postClientClientReminderApi = createAsyncThunk(
  Endpoints.POST_CLIENT_REMINDER,
  async (payload, { rejectWithValue }) => {
    try {
      return await postClientClientReminder(payload);
    } catch (error) {
      return rejectWithValue(error.response?.data || "An error occurred");
    }
  }
);
const workoutHistorySlice = createSlice({
  name: "clientReminder",
  initialState: {
    ClientReminderLoad: null,
    isloading: false,
    error: null,
    successMessage: null,
    updateSuccessMessage: "",
    updateFailedMessage: "",
  },
  reducers: {
    clearUpdateMessage: (state) => {
      state.updateSuccessMessage = "";
      state.updateFailedMessage = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchClientReminderThunk.pending, (state) => {
        state.isloading = true;
        state.error = null;
      })
      .addCase(fetchClientReminderThunk.fulfilled, (state, action) => {
        state.isloading = false;
        state.ClientReminderLoad = action.payload;
      })
      .addCase(fetchClientReminderThunk.rejected, (state, action) => {
        state.isloading = false;
        state.error = action.payload;
        state.ClientReminderLoad = [];
      })

      .addCase(postClientClientReminderApi.pending, (state) => {
        state.isloading = true;
        state.error = null;
      })
      .addCase(postClientClientReminderApi.fulfilled, (state, action) => {
        state.isloading = false;
        state.ClientReminderLoad = action.payload;
        state.updateSuccessMessage =
          action.payload?.message || "Client reminder changed";
      })
      .addCase(postClientClientReminderApi.rejected, (state, action) => {
        state.isloading = false;
        state.error = action.payload;
        state.updateFailedMessage =
          action.payload?.message || "Failed to change client reminder";
      });
  },
});

export const { clearUpdateMessage } = workoutHistorySlice.actions;

export const clientReminderReducer = workoutHistorySlice.reducer;
